import { Component, effect, inject, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { ApiService } from '../../../services/api.service';
import { NgIf } from '@angular/common';


@Component({
  selector: 'app-contact-us',
  imports: [FontAwesomeModule, HeaderComponent, FooterComponent, NgIf],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent {
  @Input() id: number | null = null;

  contactEmail!: string;
  faEnvelope = faEnvelope;
  private readonly apiService = inject(ApiService)

  // contactSignal= signal<IContactUs | null>(null);

  contactSignal = this.apiService.contactUsSignal;


  constructor() {
    effect(() => {
      // this.contactSignal = this.apiService.contactUsSignal();
    })

  }

  ngOnInit() {
    this.contactEmail = 'emailexample@frontstream.com';
    this.onContactUs()
  }

  onContactUs() {
    this.apiService.getContactUs(this.id!).subscribe({
      next: (response) => {
        // console.log('Error response:', response);

      },
      error: (error) => {
        console.error('Error response:', error);
      }
    })
  }
}
